import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './MyCalendar.css';
import profileImage from './profile.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faMedium } from '@fortawesome/free-brands-svg-icons';

const API_URL = 'https://keys.treasure3210.workers.dev/api/calendar';

function MyCalendar() {
  const [date, setDate] = useState(new Date());
  const [events, setEvents] = useState({});

  const fetchEvents = async () => {
    try {
      const response = await fetch(API_URL);
      if (!response.ok) {
        throw new Error('Failed to fetch data from Cloudflare Workers');
      }
      const data = await response.json();
      setEvents(data.record);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const tileContent = ({ date, view }) => {
    if (view === 'month' || view === 'year') {
      const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      const event = events[key];
      return event && (
        <div className="dot-container">
          <div className="dot"></div>
        </div>
      );
    }
    if (view === 'day') {
      const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      const event = events[key];
      return event && (
        <div className="dot-container-day">
          <div className="dot-day"></div>
        </div>
      );
    }
    return null;
  };

  const onDateChange = (newDate) => {
    setDate(newDate);
  };

  const eventText = () => {
    const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const eventList = events[key];
    if (eventList) {
      return (
        <div className="event-wrapper">
          {eventList.map(event => (
            <div className="event-container" key={event.title}>
              <div className="event-title">{event.title}</div>
              {event.url && <a className="event-link" href={event.url} target="_blank" rel="noopener noreferrer">(link)</a>}
              <div className="event-method">{event.method}</div>
              <div className="event-details">
                <div className="event-day event-detail">Day: {event.day}</div>
                <div className="event-time event-detail">Time: {event.time}</div>
              </div>
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="event-wrapper">
          <div className="no-event-container">
            <p>There are no events</p>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="profile-image-container">
        <img className="profile-image" src={profileImage} alt="Profile" />
      </div>
      <div className="calendar-wrapper">
        <div className="calendar-container">
          <h1>Calgary Tech Events</h1>
          <Calendar
            onChange={onDateChange}
            value={date}
            tileContent={tileContent}
            locale="en"
            formatShortWeekday={(locale, date) =>
              new Intl.DateTimeFormat(locale, { weekday: 'short', weekStartsOn: 0 }).format(date)
            }
          />
        </div>
        <div className="event-text">
          {eventText()}
        </div>
      </div>
      <div className="made-with-react">
        <p>Made with React.js by Noobie!</p>
        <p>I am an iOS Developer &#xF8FF;</p>
        <p>I Manually search for all events and add it here if it looks useful and interesting!</p>
        <p>Learn more about me below:</p>
      </div>
      <div className="social-icons">
        <a href="https://linkedin.com/in/noobietubie" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faLinkedin} size="2x" color="#0077B5" />
        </a>
        <a href="https://github.com/treasure3210" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faGithub} size="2x" color="#333" />
        </a>
        <a href="https://medium.com/@treasure3210" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faMedium} size="2x" color="#333" />
        </a>
      </div>
    </>
  );

}

export default MyCalendar;